$(document).ready(function () {
  $('.team-member').on('click', function () {
    if ($(this).data('open') !== true) {
      $(this).data('open', true);
      $(this).find('.team-member__description').slideDown(200);
    } else {
      $(this).data('open', false);
      $(this).find('.team-member__description').slideUp(200);
    }
  });

  $('.team-member').on('mouseenter', function () {
    $(this).find('.team-member__description').slideDown(200);
  });

  $('.team-member').on('mouseleave', function () {
    if ($(this).data('open') !== true) {
      $(this).find('.team-member__description').slideUp(200);
    }
  });
});